import { render, staticRenderFns } from "./InterfaceCombobox.vue?vue&type=template&id=04d48961"
import script from "./InterfaceCombobox.vue?vue&type=script&lang=js"
export * from "./InterfaceCombobox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports